// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3J028","modalFooterButton":"ModalNotes_modalFooterButton__3pmUv"};